import * as React from 'react';
import Bread from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';

export type Leaf = {
  name: string;
  url: string;
};

type BreadcrumbProps = {
  className?: string;
  tree: Leaf[];
};

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ tree, className }) => {
  return (
    <Bread
      className={className}
      separator={
        <img src='/chevron-right.svg' className='text-neutral-70 h-6 w-6' />
      }
      aria-label='breadcrumb'
    >
      {tree.map((leaf, index) => (
        <Link
          aria-disabled={index === tree.length - 1}
          key={`${leaf.name}-${index}`}
          underline='hover'
          onClick={(e) => {
            if (index === tree.length - 1) {
              e.preventDefault();
            }
          }}
          className={`text-sm ${index === tree.length - 1 ? 'text-neutral-70 hover:no-underline pointer-events-none' : ''}`}
          color={'inherit'}
          href={leaf.url}
        >
          {leaf.name}
        </Link>
      ))}
    </Bread>
  );
};
